module.exports = __webpack_public_path__ + "static/media/Together-SCIPWeb.cd426d62.mp4";